import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-developer/settings/rating-criterias";
const apiTogglle=API_BASE_URL_ENV() + "/sales-developer/settings/toggle-activation/RatingCriteria"
 const apiDropDownEndpoint=API_BASE_URL_ENV() + "/admin/settings/dropdown/RatingCriteria?status=1"
 
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
   
    toggleStatus(id, params = []) {
        return http.get(`${apiTogglle}/${id}` ,{ params });
      }

      getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
      }
}
